module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAABQCAYAAADRLL+hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABaSURBVHgB7dVRCYBAEATQ8Rh7GOEibASNYDIjWOEiXBMLLOgtKooYYQYWlsf8T7eNNpBcAFi76u4Te3LdgYwzOQrpBXcs4SdCoVAoFD5YPlZTm5o5ngtKTM8BzhYVMFOJqSwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rectangle-7.png
// module id = ADRq
// module chunks = 1